module.exports = __webpack_public_path__ + "assets/img/dragonfly-flask.dc395051.png";